import type { Matter } from "@/lib/types";
import { useState } from "react";

export function useMatterPrimaryContact(
  matter: Matter,
  selectedPeopleIds: string[],
) {
  const initialPrimaryUserId =
    matter.assignees.find(
      (assignee) => !assignee.dateTimeEnd && assignee.primaryContact,
    )?.user.id ?? null;
  const [primaryUserId, setPrimaryUserId] = useState<string | null>(
    initialPrimaryUserId,
  );
  const selectedPrimaryUserId =
    primaryUserId && selectedPeopleIds.includes(primaryUserId)
      ? primaryUserId
      : null;
  return {
    primaryUserId: selectedPrimaryUserId,
    setPrimaryUserId,
    changed: selectedPrimaryUserId !== initialPrimaryUserId,
  };
}
